import { useState } from "react";
import { createInvoicePayment } from "../../api/invoiceService";

export const useCreateInvoicePayment = (successCallback) => {
  const [creating, setCreating] = useState(false);
  const create = async (data) => {
    setCreating(true);
    try {
      const newRecord = await createInvoicePayment(data);
      setCreating(false);
      if (successCallback)
      {
        successCallback(newRecord);
      }
        return newRecord;
    } catch (error) {
      setCreating(false);
      console.error("Failed to create invoice payment:", error);
      throw error; // rethrow so the component can handle errors
    }
  };

  return { create, creating };
};